/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PamDocumentQueueSummary } from './PamDocumentQueueSummary';
import {
    PamDocumentQueueSummaryFromJSON,
    PamDocumentQueueSummaryFromJSONTyped,
    PamDocumentQueueSummaryToJSON,
} from './PamDocumentQueueSummary';
import type { ResultRange } from './ResultRange';
import {
    ResultRangeFromJSON,
    ResultRangeFromJSONTyped,
    ResultRangeToJSON,
} from './ResultRange';
import type { PageSort } from './PageSort';
import {
    PageSortFromJSON,
    PageSortFromJSONTyped,
    PageSortToJSON,
} from './PageSort';

/**
 * 
 * @export
 * @interface PagePamDocumentQueueSummary
 */
export interface PagePamDocumentQueueSummary {
    /**
     * 
     * @type {Array<PamDocumentQueueSummary>}
     * @memberof PagePamDocumentQueueSummary
     */
    results: Array<PamDocumentQueueSummary>;
    /**
     * 
     * @type {number}
     * @memberof PagePamDocumentQueueSummary
     */
    totalResults: number;
    /**
     * 
     * @type {PageSort}
     * @memberof PagePamDocumentQueueSummary
     */
    sort: PageSort;
    /**
     * 
     * @type {ResultRange}
     * @memberof PagePamDocumentQueueSummary
     */
    resultRange: ResultRange;
}

/**
 * Check if a given object implements the PagePamDocumentQueueSummary interface.
 */
export function instanceOfPagePamDocumentQueueSummary(value: object): value is PagePamDocumentQueueSummary {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('totalResults' in value) || value['totalResults'] === undefined) return false;
    if (!('sort' in value) || value['sort'] === undefined) return false;
    if (!('resultRange' in value) || value['resultRange'] === undefined) return false;
    return true;
}

export function PagePamDocumentQueueSummaryFromJSON(json: any): PagePamDocumentQueueSummary {
    return PagePamDocumentQueueSummaryFromJSONTyped(json, false);
}

export function PagePamDocumentQueueSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagePamDocumentQueueSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(PamDocumentQueueSummaryFromJSON)),
        'totalResults': json['totalResults'],
        'sort': PageSortFromJSON(json['sort']),
        'resultRange': ResultRangeFromJSON(json['resultRange']),
    };
}

export function PagePamDocumentQueueSummaryToJSON(value?: PagePamDocumentQueueSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'results': ((value['results'] as Array<any>).map(PamDocumentQueueSummaryToJSON)),
        'totalResults': value['totalResults'],
        'sort': PageSortToJSON(value['sort']),
        'resultRange': ResultRangeToJSON(value['resultRange']),
    };
}

